import AppAdapter from 'adapters/app';

class EventAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static userId = '';
	static providerId = '';
}

export default EventAdapter;